import "./Notification.css";

import { Breadcrumb, message, Table, type TableColumnsType } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { SectionHeader, TableMenuDropdown } from "../../_lib/_components";
import {
  deleteNotification,
  getNotifications,
  type NotificationType,
  useAppSelector,
} from "../../_lib/_store";

export const NotificationPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, notifications } = useAppSelector(
    (state) => state.notification,
  );
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getNotifications(messageApi);
  };

  const columns: TableColumnsType<NotificationType> = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      ellipsis: true,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type) => (
        <span
          style={{
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            backgroundColor:
              type === "Success"
                ? "#f6ffed"
                : type === "Warning"
                  ? "#fff7e6"
                  : type === "Error"
                    ? "#fff2f0"
                    : "#f0f5ff",
            color:
              type === "Success"
                ? "#52c41a"
                : type === "Warning"
                  ? "#fa8c16"
                  : type === "Error"
                    ? "#ff4d4f"
                    : "#1890ff",
          }}
        >
          {type}
        </span>
      ),
    },
    {
      title: "Target Audience",
      dataIndex: "targetAudience",
      key: "targetAudience",
    },
    {
      title: "Push",
      dataIndex: "sendPushNotification",
      key: "sendPushNotification",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      title: "Email",
      dataIndex: "sendEmailNotification",
      key: "sendEmailNotification",
      render: (value) => (value ? "Yes" : "No"),
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: NotificationType) => {
    switch (key) {
      case "show":
        navigate(`/notification/show`, { state: { notification: obj } });
        break;
      case "edit":
        navigate(`/notification/edit`, { state: { notification: obj } });
        break;
      case "delete":
        deleteNotification(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="category">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: "Notification",
            },
          ]}
        />
        <SectionHeader
          dataLength={notifications.length}
          createRoute="notification"
        />
        <Table
          dataSource={notifications}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1000 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
